import { createAction, props } from "@ngrx/store"

export const fetchPayrolls = createAction(
    '[Payroll Module] fetch payrolls',
    props<{merchantId: string}>()
)

export const fetchPayrollsFailed = createAction(
    '[Payroll Module] STATUS: fetch payrolls failed'
)

export const fetchPayrollsSuccess = createAction(
    '[Payroll Module] STATUS: fetch payrolls success',
    props<{payrolls: any}>()
)

export const fetchPayroll = createAction(
    '[Payroll Module] fetch payroll',
    props<{merchantId: string, payrollId: string}>()
)

export const fetchPayrollFailed = createAction(
    '[Payroll Module] STATUS: fetch payroll failed'
)

export const fetchPayrollSuccess = createAction(
    '[Payroll Module] STATUS: fetch payroll success',
    props<{payroll: any}>()
)

export const createPayroll = createAction(
    '[Payroll Module] create payroll',
    props<{payrollDto: any}>()
)

export const createPayrollFailed = createAction(
    '[Payroll Module] STATUS: create payroll failed'
)

export const createPayrollSuccess = createAction(
    '[Payroll Module] STATUS: create payroll success',
    props<{response: any}>()
)

export const updatePayroll = createAction(
    '[Payroll Module] update payroll',
    props<{payrollDto: any, payrollId: string}>()
)

export const updatePayrollFailed = createAction(
    '[Payroll Module] STATUS: update payroll failed'
)

export const updatePayrollSuccess = createAction(
    '[Payroll Module] STATUS: update payroll success',
    props<{response: any}>()
)
